import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 4.375rem 1fr;
  grid-row-gap: 1rem;
  max-width: 100%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;
